import React, { useState } from 'react';
import { BasicDialog, PrimaryButton, Text } from 'library';
import BusinessDatesAndTimes from '../../DateAndTimePage/BusinessDatesAndTimes';
import { useJobFormContext } from 'parent-portal/forms/JobFormContext';

export default function EditSchedulesModal({
    open,
    onClose,
    headline,
}: {
    open: boolean;
    onClose: () => void;
    headline: string;
}) {
    const { form } = useJobFormContext();
    const {
        daysOfTheWeek,
        startDate,
        endDate,
        jobDate,
        jobTimes,
        sameTimes,
        businessJobType,
        requestType,
        breakRequired,
        breakLength,
        slotsAvailable,
    } = form.fieldStates;
    const [isValid, setIsValid] = useState(false);

    function save() {
        onClose();
    }

    return (
        <BasicDialog isOpen={open} onClose={onClose} closeButton style={{ minWidth: '45%', padding: 30 }}>
            <Text variant="h1" bold>
                Edit {headline} Schedule
            </Text>
            <BusinessDatesAndTimes
                {...{
                    daysOfTheWeek,
                    startDate,
                    endDate,
                    jobDate,
                    jobTimes,
                    sameTimes,
                    businessJobType,
                    requestType,
                    setIsValid,
                    breakRequired,
                    breakLength,
                    slotsAvailable,
                }}
            />
            <PrimaryButton onClick={save} leftAlign disabled={!isValid}>
                Save
            </PrimaryButton>
        </BasicDialog>
    );
}
